export const rolesType = [
  {
    key: "Administrator",
    value: "مدیر",
  },
  {
    key: "Executor",
    value: "مجری",
  },
  {
    key: "Engineer",
    value: "کارشناس",
  },
  {
    key: "Employee",
    value: "کارمند",
  },
  {
    key: "Accountant",
    value: "حسابدار",
  },
  {
    key: "Section",
    value: "شهرستان",
  },
  {
    key: "Installer",
    value: "نصاب",
  },
  {
    key: "Administrative",
    value: "اداری",
  },
    {
    key: "Nezam",
    value: "نظام مهندسی",
  },
   {
    key: "Nezarat",
    value: "نظارت",
  },
]
